/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://f02azgi4ic.execute-api.us-east-2.amazonaws.com/bakyprod",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://aoipyc3qxrat5j3z7wnxw7xqhq.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-6itvpgfthfeldeyoc6uzobuabq",
    "aws_cognito_identity_pool_id": "us-east-2:b113148c-a72c-4f04-a945-a7ee6a5e1461",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_BUWEi5woA",
    "aws_user_pools_web_client_id": "4n20f6rschr5pvh7ft2cfe7hmb",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
